import { useMissionsTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const ShiftInfoCard = ({ shift }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Box, { width: '100%', sx: { backgroundColor: themeColors.surface.secondary, p: 2, borderRadius: 1 } },
        React.createElement(Box, { component: 'dl', sx: {
                display: 'grid',
                gridTemplateColumns: 'auto 1fr',
                rowGap: 1,
                columnGap: 6,
                alignItems: 'center',
                m: 0,
            } },
            React.createElement(Typography, { component: 'dt', variant: 'body2', color: themeColors.text.subtle, sx: { m: 0 } }, t('common.date')),
            React.createElement(Typography, { component: 'dd', variant: 'body2', sx: { m: 0 } }, t('date', { value: shift.columns.startTime })),
            React.createElement(Typography, { component: 'dt', variant: 'body2', color: themeColors.text.subtle, sx: { m: 0 } }, t('common.time')),
            React.createElement(Typography, { component: 'dd', variant: 'body2', sx: { m: 0 } }, `${t('time', { value: shift.columns.startTime })} - ${t('time', { value: shift.columns.stopTime })}`),
            React.createElement(Typography, { component: 'dt', variant: 'body2', color: themeColors.text.subtle, sx: { m: 0 } }, t('common.county')),
            React.createElement(Typography, { component: 'dd', variant: 'body2', sx: { m: 0 } }, shift.columns.countyName))));
};
